/* src/components/update-notification-modal/update-notification-modal.component.scss */
:host {
  display: block;
}
.datepicker {
  display: inline-block;
  vertical-align: middle;
  width: 15rem;
}
.datepicker-clear-button {
  --vwui-btn-icon--icon-size: 0.75rem;
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 0.5rem;
}
.scrollable-body {
  overflow: auto;
  max-height: 60vh;
  padding-right: 20px;
}
/*# sourceMappingURL=update-notification-modal.component-JXORWS4F.css.map */
